import { fetchLegsForOrder } from './http/platform-ws/legQueries';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { OrderLegResult } from '@thinkalpha/platform-ws-client/contracts/trading.js';

export const LEGS_QUERY_KEY = 'order-legs';

/**
 * Creates query options for fetching legs data for a multi-leg order.
 *
 * @param clOrdId - The client order ID to fetch legs for (undefined disables the query)
 * @returns Query options for use with useQuery/useQuery
 */
export const getLegsForOrderQuery = (clOrdId: string | undefined): UseQueryOptions<OrderLegResult[] | undefined> => ({
    queryKey: [LEGS_QUERY_KEY, clOrdId],
    queryFn: () => (clOrdId ? fetchLegsForOrder(clOrdId) : Promise.resolve(undefined)),
    enabled: !!clOrdId,
    staleTime: 30_000, // Cache for 30 seconds
});
